<template>
  <section class="ui-section">
    <h3>{{ title }}</h3>
    <slot></slot>
  </section>
</template>

<script>
/** Odjeljak u panelu: mali naslov velikim slovima i sadržaj ispod. */
export default {
  name: "UiSection",
  props: { title: { type: String, required: true } },
};
</script>
